import { AxiosResponse } from 'axios';
import { doorClient } from '.';

function resolve<T>(promise: Promise<AxiosResponse<T>>) {
  return promise.then((response) => {
    return response.data;
  });
}
export function reportCase(body: Feedback.ReportCase) {
  return resolve(doorClient.post('/oversea-user-voice/v1/case', body));
}

export interface CaseListParams {
  caseStatus: Feedback.CaseStatus[];
  feedback?: 1 | 2;
  pageNum: number;
  pageSize: number;
}

export interface CaseListResponse {
  caseBasicInfo: Feedback.CaseBasicInfo[];
  caseStatusCount: {
    caseStatus: Feedback.CaseStatus;
    count: number;
  }[];
  pageNum: number;
  pageSize: number;
}

export function caseList(params: CaseListParams) {
  return resolve(doorClient.post<CaseListResponse>('/oversea-user-voice/v1/case/list', params));
}

export interface CaseResponse {
  caseBasicInfo: Feedback.CaseBasicInfo;
  operateLog: Feedback.CaseOperateLog[];
}

export interface AgentFeedbackMessage {
  id: string;
  role: 'user' | 'agent';
  content: string;
}

/** 历史消息由详情接口补充；旧服务或查询失败时继续展示提交时的快照。 */
export function getAgentFeedbackMessages(info: Feedback.CaseBasicInfo): AgentFeedbackMessage[] {
  const context = info.agentContext;
  if (!context) return [];
  try {
    const messages: unknown = JSON.parse(info.message).agentMessages;
    if (Array.isArray(messages) && messages.length > 0 && messages.every(
      (item): item is AgentFeedbackMessage => item !== null && typeof item === 'object' &&
        typeof item.id === 'string' && (item.role === 'user' || item.role === 'agent') &&
        typeof item.content === 'string',
    ) && messages.some((item) => item.id === context.messagePublicId && item.role === 'agent')) {
      return messages;
    }
  } catch {
    // 保留一问一答，不让旧快照或异常数据影响详情页。
  }
  return [
    { id: 'snapshot-question', role: 'user', content: context.questionContent },
    { id: context.messagePublicId, role: 'agent', content: context.replyContent },
  ];
}

export function caseDetail(caseId: number) {
  return resolve(doorClient.get<CaseResponse>(`/oversea-user-voice/v1/case/${caseId}/detail`));
}

export function closeCase(caseId: number) {
  return resolve(doorClient.put(`/oversea-user-voice/v1/case/${caseId}/close`, null));
}

interface FeedbackBody {
  // 操作人id
  userId: number;
  // 反馈描述
  desc: string;
  // 操作人名称
  userName: string;
}

// 重新提交反馈
export function resubmitFeedback(caseId: number, body: FeedbackBody) {
  return resolve(
    doorClient.post<CaseListResponse>(`/oversea-user-voice/v1/case/${caseId}/feedback`, body),
  );
}
